export const deepMerge = (obj1: Record<string, unknown>, obj2: Record<string, unknown>): void => {
  for (const key in obj2) {
    if (Object.prototype.hasOwnProperty.call(obj2, key)) {
      if (
        obj2[key] instanceof Object &&
        obj1[key] instanceof Object &&
        !Array.isArray(obj2[key]) &&
        !Array.isArray(obj1[key])
      ) {
        deepMerge(obj1[key] as Record<string, unknown>, obj2[key] as Record<string, unknown>);
      } else {
        obj1[key] = obj2[key];
      }
    }
  }
};
